import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Cable, LayoutDashboard, Users, ClipboardList, Building2, Briefcase, BarChart3, Settings, LogOut } from "lucide-react";

const NAV = [
  { to: "/admin/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "anav-dashboard" },
  { to: "/admin/candidates", label: "Candidate Search", icon: Users, testid: "anav-candidates" },
  { to: "/admin/requirements", label: "Requirements", icon: ClipboardList, testid: "anav-requirements" },
  { to: "/admin/employers", label: "Employers", icon: Building2, testid: "anav-employers" },
  { to: "/admin/jobs", label: "Jobs", icon: Briefcase, testid: "anav-jobs" },
  { to: "/admin/analytics", label: "Analytics", icon: BarChart3, testid: "anav-analytics" },
  { to: "/admin/settings", label: "Settings", icon: Settings, testid: "anav-settings" },
];

export default function AdminShell({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  return (
    <div className="min-h-screen bg-slate-100 flex">
      <aside className="hidden lg:flex flex-col w-60 bg-slate-900 text-slate-300 fixed inset-y-0">
        <div className="h-16 flex items-center gap-2 px-5 border-b border-slate-800">
          <div className="w-8 h-8 rounded-lg copper-gradient flex items-center justify-center"><Cable className="w-4 h-4 text-white" /></div>
          <span className="font-display font-extrabold text-white">Cable<span className="text-[#D96B27]">Careers</span></span>
        </div>
        <nav className="flex-1 p-3 space-y-1 overflow-y-auto scrollbar-thin">
          {NAV.map((n) => {
            const active = location.pathname === n.to;
            return (
              <Link key={n.to} to={n.to} data-testid={n.testid} className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${active ? "bg-[#D96B27] text-white" : "hover:bg-slate-800 hover:text-white"}`}>
                <n.icon className="w-4 h-4" /> {n.label}
              </Link>
            );
          })}
        </nav>
        <div className="p-3 border-t border-slate-800">
          <div className="px-3 py-2 text-xs text-slate-500 truncate">{user?.email}</div>
          <button onClick={logout} className="flex items-center gap-3 px-3 py-2 w-full rounded-lg text-sm hover:bg-slate-800 hover:text-white"><LogOut className="w-4 h-4" />Logout</button>
        </div>
      </aside>

      <div className="flex-1 lg:ml-60">
        <header className="lg:hidden h-14 bg-slate-900 flex items-center px-4 gap-2 overflow-x-auto">
          {NAV.map((n) => (
            <button key={n.to} onClick={() => navigate(n.to)} className={`text-xs whitespace-nowrap px-3 py-1.5 rounded-full ${location.pathname === n.to ? "bg-[#D96B27] text-white" : "text-slate-300 bg-slate-800"}`}>{n.label}</button>
          ))}
        </header>
        <main className="p-4 sm:p-6">{children}</main>
      </div>
    </div>
  );
}
